<div
  #warningAlert
  class="zp-billing-notifier__alert status--warning"
  [class.alert--visible]="isSoftWarning"
>
  <p>
    To receive a payout your invoice details must be completed.
    <a
      routerLink="/account/billing-info"
      href="javascript:void(0)"
      [cwGtmId]="['billing-notifier', 'Go-to-billing-information']"
      (click)="onCloseSoftWarning()"
    >Go to billing information</a>
  </p>

  <p-button
    icon="pi pi-times"
    [rounded]="true"
    [text]="true"
    size="small"
    severity="secondary"
    [style]="{color: '#fff', 'background-color': 'transparent'}"
    [cwGtmId]="['billing-notifier', 'Close-message']"
    (click)="onCloseSoftWarning()"
  />
</div>

<div
  #warningBillingDataAlert
  class="zp-billing-notifier__alert status--error"
  [class.alert--visible]="isSoftWarningBillingData"
>
  <p>
    Your billing data is invalid. Please
    <a
      routerLink="/account/billing-info"
      href="javascript:void(0)"
      [cwGtmId]="['billing-notifier', 'Go-to-billing-information']"
      (click)="onCloseSoftWarningBillingData()"
    >correct the account information</a>
    in order to receive payment or
    contact us.
  </p>

  <p-button
    icon="pi pi-times"
    [rounded]="true"
    [text]="true"
    size="small"
    severity="secondary"
    [style]="{color: '#fff', 'background-color': 'transparent'}"
    [cwGtmId]="['billing-notifier', 'Close-message']"
    (click)="onCloseSoftWarningBillingData()"
  />
</div>

<p-dialog
  [(visible)]="isHardWarning"
  [modal]="true"
>
  <ng-template #closeicon>
    <p-button
      icon="pi pi-times"
      [rounded]="true"
      [text]="true"
      severity="secondary"
      [cwGtmId]="['billing-notifier', 'Close-message']"
      (click)="onCloseHardWarning()"
    />
  </ng-template>
  <div class="zp-billing-notifier__popup">
    <h3>We have some money for you!</h3>
    <p>Fill in your invoice details first.</p>
  </div>

  <ng-template #footer>
    <p-button
      label="Go to billing information"
      size="small"
      [cwGtmId]="['billing-notifier', 'Go-to-billing-information']"
      (click)="goToBillingDetails(); onCloseHardWarning()"
    />
  </ng-template>
</p-dialog>
